import { createFileRoute } from '@tanstack/react-router';
import { PAYMENT_ADMIN_SOURCES } from '@/api/payment-admin/models';
import { PaymentDetailRoute } from '@/pages/acube-payments/detail-route';

/**
 * Deep link a un bonifico senza riga nel registro ACube (id del
 * `SepaPayment`): endpoint e azioni diversi da quelli di `$id`, quindi una
 * rotta sua e non un parametro di search da tenere allineato.
 */
export const Route = createFileRoute(
  '/admin/_layout/acube-payments/_layout/sepa/$id'
)({
  component: SepaPaymentDetailRouteComponent,
});

function SepaPaymentDetailRouteComponent() {
  const { id } = Route.useParams();

  return (
    <PaymentDetailRoute target={{ source: PAYMENT_ADMIN_SOURCES.SEPA, id }} />
  );
}
